import { render } from "./custom-checkbox.vue?vue&type=template&id=6e67f628"
import script from "./custom-checkbox.vue?vue&type=script&lang=js"
export * from "./custom-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__